import Joyride from "react-joyride";
import { useLocation } from "react-router-dom";
import { useContext, useMemo, } from "react";
import { joyrideStepsRules } from "./JoyrideSteps/JoyrideSteps.tsx";
import { ThemeContext } from "../../context/ThemeContext.js";
import { useJoyride } from "./JoyrideContext.tsx";

export default function JoyrideTest() {
  const { themeConfig } = useContext(ThemeContext);
  const location = useLocation();
  const { startJoyRide, setStartJoyRide, selectedTab, } = useJoyride();
  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const path = useMemo(
    () => location.pathname.replace(/\/$/, "") || "/",
    [location.pathname]
  );

  const steps = useMemo(() => {
    const matchedRule = joyrideStepsRules.find(({ match }) =>
      match(path, query, selectedTab)  
    );
    if (!matchedRule) return [];

    const rawSteps =
      typeof matchedRule.steps === "function"
        ? matchedRule.steps(path, query, selectedTab) 
        : matchedRule.steps;

    return rawSteps || [];
  }, [path, query, selectedTab]); 

const key = useMemo(
  () => `${path}-${selectedTab}-${steps.length}`,
  [path, selectedTab, steps]
);

  const modifiedSteps = useMemo(
    () =>
      steps.map((step: any) => ({
        ...step,
        disableBeacon: true,
        spotlightPadding: 0,
      })),
    [steps]
  );

  if (!startJoyRide || modifiedSteps.length === 0) return null;

  return (
    <Joyride
      key={key}
      run={startJoyRide}
      steps={modifiedSteps}
      continuous
      scrollToFirstStep
      showProgress
      showSkipButton
      hideCloseButton
      disableScrolling={false}
      styles={{
        options: {
          zIndex: 10000,
          backgroundColor: themeConfig.colors.background,
          textColor: themeConfig.colors.text,
        },
        tooltip: { padding: "4px 8px", border: "1px solid white" },
        buttonNext: {
          margin: "4px",
          backgroundColor: themeConfig.colors.primary,
          color: "#fff",
        },
        buttonBack: { margin: "4px" },
      }}
      callback={({ status }) => {
        if (["finished", "skipped"].includes(status)) {
          setStartJoyRide?.(false);
        }
      }}
    />
  );
}
